import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const FooterContainer = styled.footer`
  position: relative;
  z-index: 1;
  border-top: 1px solid rgb(var(--fg) / 0.07);
  background: rgb(var(--bg) / 0.6);
  backdrop-filter: blur(24px) saturate(1.3);
  -webkit-backdrop-filter: blur(24px) saturate(1.3);
`;

const FooterInner = styled.div`
  padding: 1.2rem 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;

  @media (max-width: 480px) {
    padding: 1rem 1rem;
    gap: 0.8rem;
  }
`;

const FooterText = styled.p`
  color: rgb(var(--gray) / 0.85);
  font-size: 0.82rem;
  letter-spacing: 0.03em;
  margin: 0;

  a {
    color: rgb(var(--gray) / 0.85);
    text-decoration: none;
    transition: color 0.3s;
    &:hover { color: rgb(var(--fg) / 0.85); }
  }

  @media (max-width: 480px) {
    font-size: 0.72rem;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 0.8rem;

  a {
    color: rgb(var(--gray) / 0.7);
    font-size: 1rem;
    transition: color 0.3s;
    display: inline-flex;
    &:hover { color: rgb(var(--fg) / 0.85); }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterInner>
        <FooterText>
          <a
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            target="_blank"
            rel="noopener noreferrer"
          >
            &copy; {new Date().getFullYear()} Kyriakos Papadopoulos. All rights reserved (probably).
          </a>
        </FooterText>
        <FooterLinks>
          <a
            href="https://www.linkedin.com/in/papadopoulos-kyriakos/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/kyriakos-papadopoulos"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
        </FooterLinks>
      </FooterInner>
    </FooterContainer>
  );
};

export default Footer;
